// You can write more code here

import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { SizedElement } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/LayoutGroupUtils';
import StudentGameAttemptUIController from '@/game/prefabs/StudentGame/StudentGameAttemptUI/StudentGameAttemptUIController';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class StudentGameAttemptUI extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// attemptBacking
		const attemptBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 148, 18, 4, 4, 4, 4);
		attemptBacking.scaleX = 4;
		attemptBacking.scaleY = 4;
		attemptBacking.setOrigin(0, 0);
		desktopView.add(attemptBacking);

		// textMask
		const textMask = scene.add.rectangle(16, 36, 512, 64);
		textMask.setOrigin(0, 0.5);
		textMask.alpha = 0.000001;
		textMask.isFilled = true;
		desktopView.add(textMask);

		// attemptResultIcon
		const attemptResultIcon = scene.add.image(556, 36, "tick");
		attemptResultIcon.scaleX = 4;
		attemptResultIcon.scaleY = 4;
		desktopView.add(attemptResultIcon);

		// speedBonusContainer
		const speedBonusContainer = scene.add.container(624, 36);
		speedBonusContainer.scaleX = 2;
		speedBonusContainer.scaleY = 2;
		desktopView.add(speedBonusContainer);

		// speedBonusIcon
		const speedBonusIcon = scene.add.image(0, 0, "stopwatch");
		speedBonusIcon.scaleX = 2;
		speedBonusIcon.scaleY = 2;
		speedBonusContainer.add(speedBonusIcon);

		// resultsTextContainer
		const resultsTextContainer = scene.add.container(0, 0);
		desktopView.add(resultsTextContainer);

		// attemptTargetAnswerText
		const attemptTargetAnswerText = scene.add.bitmapText(20, 36, "Aronui", "MAT");
		attemptTargetAnswerText.setOrigin(0, 0.5);
		attemptTargetAnswerText.visible = false;
		attemptTargetAnswerText.tintTopLeft = 5387071;
		attemptTargetAnswerText.tintTopRight = 5387071;
		attemptTargetAnswerText.tintBottomLeft = 5387071;
		attemptTargetAnswerText.tintBottomRight = 5387071;
		attemptTargetAnswerText.text = "MAT";
		attemptTargetAnswerText.fontSize = -32;
		resultsTextContainer.add(attemptTargetAnswerText);

		// answerTextContainer
		const answerTextContainer = scene.add.container(20, 36);
		resultsTextContainer.add(answerTextContainer);

		// attemptStudentAnswerText
		const attemptStudentAnswerText = scene.add.bitmapText(256, 36, "Aronui", "MAT");
		attemptStudentAnswerText.setOrigin(0, 0.5);
		attemptStudentAnswerText.visible = false;
		attemptStudentAnswerText.tintTopLeft = 5387071;
		attemptStudentAnswerText.tintTopRight = 5387071;
		attemptStudentAnswerText.tintBottomLeft = 5387071;
		attemptStudentAnswerText.tintBottomRight = 5387071;
		attemptStudentAnswerText.text = "MAT";
		attemptStudentAnswerText.fontSize = -24;
		resultsTextContainer.add(attemptStudentAnswerText);

		// studentAttemptTextContainer
		const studentAttemptTextContainer = scene.add.container(256, 36);
		resultsTextContainer.add(studentAttemptTextContainer);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// attemptBacking_m
		const attemptBacking_m = scene.add.nineslice(0, 0, "Hud2", undefined, 164, 24, 4, 4, 4, 4);
		attemptBacking_m.scaleX = 2;
		attemptBacking_m.scaleY = 2;
		attemptBacking_m.setOrigin(0, 0);
		mobileView.add(attemptBacking_m);

		// textMask_m
		const textMask_m = scene.add.rectangle(16, 36, 256, 64);
		textMask_m.setOrigin(0, 0.5);
		textMask_m.alpha = 0.000001;
		textMask_m.isFilled = true;
		mobileView.add(textMask_m);

		// attemptResultIcon_m
		const attemptResultIcon_m = scene.add.image(288, 24, "tick");
		attemptResultIcon_m.scaleX = 2;
		attemptResultIcon_m.scaleY = 2;
		mobileView.add(attemptResultIcon_m);

		// speedBonusContainer_m
		const speedBonusContainer_m = scene.add.container(360, 36);
		speedBonusContainer_m.scaleX = 2;
		speedBonusContainer_m.scaleY = 2;
		mobileView.add(speedBonusContainer_m);

		// speedBonusIcon_m
		const speedBonusIcon_m = scene.add.image(-26, -6, "stopwatch");
		speedBonusContainer_m.add(speedBonusIcon_m);

		// resultsTextContainer_m
		const resultsTextContainer_m = scene.add.container(0, 0);
		mobileView.add(resultsTextContainer_m);

		// attemptTargetAnswerText_m
		const attemptTargetAnswerText_m = scene.add.bitmapText(20, 24, "Aronui", "MAT");
		attemptTargetAnswerText_m.setOrigin(0, 0.5);
		attemptTargetAnswerText_m.visible = false;
		attemptTargetAnswerText_m.tintTopLeft = 5387071;
		attemptTargetAnswerText_m.tintTopRight = 5387071;
		attemptTargetAnswerText_m.tintBottomLeft = 5387071;
		attemptTargetAnswerText_m.tintBottomRight = 5387071;
		attemptTargetAnswerText_m.text = "MAT";
		attemptTargetAnswerText_m.fontSize = -16;
		resultsTextContainer_m.add(attemptTargetAnswerText_m);

		// attemptStudentAnswerText_m
		const attemptStudentAnswerText_m = scene.add.bitmapText(168, 24, "Aronui", "MAT");
		attemptStudentAnswerText_m.setOrigin(0, 0.5);
		attemptStudentAnswerText_m.visible = false;
		attemptStudentAnswerText_m.tintTopLeft = 5387071;
		attemptStudentAnswerText_m.tintTopRight = 5387071;
		attemptStudentAnswerText_m.tintBottomLeft = 5387071;
		attemptStudentAnswerText_m.tintBottomRight = 5387071;
		attemptStudentAnswerText_m.text = "MAT";
		attemptStudentAnswerText_m.fontSize = -16;
		resultsTextContainer_m.add(attemptStudentAnswerText_m);

		// answerTextContainer_m
		const answerTextContainer_m = scene.add.container(20, 24);
		resultsTextContainer_m.add(answerTextContainer_m);

		// studentAttemptTextContainer_m
		const studentAttemptTextContainer_m = scene.add.container(168, 24);
		resultsTextContainer_m.add(studentAttemptTextContainer_m);

		this.attemptBacking = attemptBacking;
		this.attemptResultIcon = attemptResultIcon;
		this.speedBonusIcon = speedBonusIcon;
		this.speedBonusContainer = speedBonusContainer;
		this.answerTextContainer = answerTextContainer;
		this.studentAttemptTextContainer = studentAttemptTextContainer;
		this.resultsTextContainer = resultsTextContainer;
		this.desktopView = desktopView;
		this.attemptBacking_m = attemptBacking_m;
		this.attemptResultIcon_m = attemptResultIcon_m;
		this.speedBonusIcon_m = speedBonusIcon_m;
		this.speedBonusContainer_m = speedBonusContainer_m;
		this.answerTextContainer_m = answerTextContainer_m;
		this.studentAttemptTextContainer_m = studentAttemptTextContainer_m;
		this.resultsTextContainer_m = resultsTextContainer_m;
		this.mobileView = mobileView;

		/* START-USER-CTR-CODE */
    this._controller = new StudentGameAttemptUIController(this);
    /* END-USER-CTR-CODE */
	}

	public attemptBacking: Phaser.GameObjects.NineSlice;
	public attemptResultIcon: Phaser.GameObjects.Image;
	public speedBonusIcon: Phaser.GameObjects.Image;
	public speedBonusContainer: Phaser.GameObjects.Container;
	public answerTextContainer: Phaser.GameObjects.Container;
	public studentAttemptTextContainer: Phaser.GameObjects.Container;
	public resultsTextContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	public attemptBacking_m: Phaser.GameObjects.NineSlice;
	public attemptResultIcon_m: Phaser.GameObjects.Image;
	public speedBonusIcon_m: Phaser.GameObjects.Image;
	public speedBonusContainer_m: Phaser.GameObjects.Container;
	public answerTextContainer_m: Phaser.GameObjects.Container;
	public studentAttemptTextContainer_m: Phaser.GameObjects.Container;
	public resultsTextContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  private _controller: StudentGameAttemptUIController;
  get controller() {
    return this._controller;
  }

  getElementSize() {
    const currentBacking =
      ResponsivenessManager.GetResponsiveComponentFromContainer(
        this,
        'attemptBacking',
        ResponsivenessManager.GetCurrentGlobalViewForGame(this.scene),
      );
    return new Phaser.Math.Vector2(
      currentBacking.displayWidth,
      currentBacking.displayHeight,
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
